export default "__VITE_ASSET__C2jcZD9b__"